/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeBreakpointContext, BaSeButton, BaSeSmall2 } from '@base/react';
import React from 'react';
import ProgressBar from '../../../components/progress-bar/progress-bar';
import { Bar, BarsSection, Block } from './dangerous-combinations-style';

// import { Container } from './styles';

function BlockRow({ description, primary, secondary, equalsValues }) {
  const { onMobileSmall, onMobile, onMobileLarge } = React.useContext(
    BaSeBreakpointContext,
  );
  const isMobile = onMobile || onMobileSmall || onMobileLarge;

  const [open, setOpen] = React.useState(true);

  const TEXT = () => <BaSeSmall2 color="#636363">{description}</BaSeSmall2>;
  const fillProgressColorPrimary = equalsValues
    ? '#0000C9'
    : primary?.greaterValue
      ? '#387F3A'
      : '#B2405B';
  const fillProgressColorSecondary = equalsValues
    ? '#0000C9'
    : secondary?.greaterValue
      ? '#387F3A'
      : '#B2405B';
  return (
    <Block>
      <BarsSection>
        <Bar>
          <ProgressBar
            max={primary?.max}
            value={primary?.value}
            title={primary?.title}
            isBold={equalsValues || primary?.greaterValue}
            colorTitle={
              equalsValues || primary?.greaterValue ? '#222' : '#636363'
            }
            controleDetailInBar={false}
            colofFillProgress={fillProgressColorPrimary}
          />
        </Bar>
        <Bar>
          <ProgressBar
            max={secondary?.max}
            value={secondary?.value}
            title={secondary?.title}
            isBold={equalsValues || secondary?.greaterValue}
            colorTitle={
              equalsValues || secondary?.greaterValue ? '#222' : '#636363'
            }
            controleDetailInBar={false}
            colofFillProgress={fillProgressColorSecondary}
          />
        </Bar>
      </BarsSection>

      {open && isMobile && TEXT()}

      {!isMobile ? (
        TEXT()
      ) : (
        <div style={{ marginLeft: 'auto' }}>
          <BaSeButton
            buttonType="button"
            color="default"
            loadingText="Carregando…"
            onClick={() => setOpen((prev) => !prev)}
            rightIcon={
              open ? 'system/arrow-down-s-line' : 'system/arrow-up-s-line'
            }
            size="small"
            type="tertiary"
            value={open ? 'Fechar' : 'Saiba mais'}
          />
        </div>
      )}
    </Block>
  );
}

export default BlockRow;
